import * as Yup from 'yup';
import { i18n } from '../../../../../i18n/index.js';

var getArrayValidators = function getArrayValidators(_ref) {
  var validators = _ref.validators,
      required = _ref.required;

  if (!validators) {
    return;
  }

  var schema = validators.reduce(function (schema, _ref2) {
    var name = _ref2.name,
        value = _ref2.value,
        customErrorMessage = _ref2.customErrorMessage;

    if (typeof value !== 'number') {
      return schema;
    }

    switch (name) {
      case 'minLength':
        schema = schema.min(value, customErrorMessage || i18n.t('There should be more than {{value}} options checked.', {
          value: value
        }));
        break;

      case 'maxLength':
        if (typeof value !== 'number') {
          break;
        }

        schema = schema.max(value, customErrorMessage || i18n.t('There should be less than {{value}} options checked.', {
          value: value
        }));
        break;
    }

    return schema;
  }, Yup.array());
  return required ? schema.required(i18n.t('This field is required')) : schema;
};

export { getArrayValidators };